var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-layout",
                [
                  _c(
                    "v-tooltip",
                    { attrs: { bottom: "" } },
                    [
                      _vm.es_registro_ad
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                slot: "activator",
                                color: "primary",
                                dark: ""
                              },
                              nativeOn: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.crearActualizarPersona({})
                                }
                              },
                              slot: "activator"
                            },
                            [
                              _c("v-icon", { attrs: { dark: "" } }, [
                                _vm._v("add")
                              ]),
                              _vm._v(" " + _vm._s(_vm.$t("common.add")))
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [_vm._v("Agregar Persona")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    { attrs: { bottom: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-refresh",
                          attrs: { slot: "activator" },
                          nativeOn: {
                            click: function($event) {
                              return function() {
                                _vm.filterShow = _vm.filterShow ? false : true
                              }.apply(null, arguments)
                            }
                          },
                          slot: "activator"
                        },
                        [_c("v-icon", [_vm._v("filter_list")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("Búsqueda/filtros")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    { attrs: { bottom: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-refresh",
                          attrs: { slot: "activator" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.listaPersonas()
                            }
                          },
                          slot: "activator"
                        },
                        [_c("v-icon", [_vm._v("refresh")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.updateList")))])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("transition", { attrs: { name: "slide-fade" } }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.filterShow,
                            expression: "filterShow"
                          }
                        ],
                        staticClass: "filter-container-rrhh"
                      },
                      [
                        _c(
                          "v-icon",
                          { attrs: { small: "", color: "primary" } },
                          [_vm._v("search")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Apellido paterno" },
                              on: { input: _vm.filterApPaterno },
                              model: {
                                value: _vm.form.ap_paterno,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "ap_paterno", $$v)
                                },
                                expression: "form.ap_paterno"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Apellido materno" },
                              on: { input: _vm.filterApMaterno },
                              model: {
                                value: _vm.form.ap_materno,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "ap_materno", $$v)
                                },
                                expression: "form.ap_materno"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Nombres" },
                              on: { input: _vm.filterNombres },
                              model: {
                                value: _vm.form.nombres,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "nombres", $$v)
                                },
                                expression: "form.nombres"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Nro Documento" },
                              on: { input: _vm.filterNroDoc },
                              model: {
                                value: _vm.form.nro_doc,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "nro_doc", $$v)
                                },
                                expression: "form.nro_doc"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "btn-filter" },
                          [
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      slot: "activator",
                                      icon: "",
                                      small: ""
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.recargar()
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("refresh")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Recargar filtros")])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { slot: "activator", icon: "" },
                                    nativeOn: {
                                      click: function($event) {
                                        return function() {
                                          _vm.filterShow = false
                                          _vm.recargar()
                                        }.apply(null, arguments)
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("close")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Cerrar filtros")])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "elevation-1 tabla-comprimida-light",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.l_personas,
                  "no-data-text": "Sin datos",
                  "no-results-text": "No se encontro coincidencias",
                  "rows-per-page-items": [
                    10,
                    25,
                    50,
                    { text: "Todo", value: -1 }
                  ],
                  "item-key": "index",
                  loading: _vm.loading,
                  pagination: _vm.pagination,
                  "rows-per-page-text": "Filas por pagina",
                  search: _vm.filters,
                  "custom-filter": _vm.customFilter
                },
                on: {
                  "update:pagination": function($event) {
                    _vm.pagination = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(items) {
                      return [
                        _c(
                          "td",
                          { staticClass: "text-xs-center py-0 px-1" },
                          [
                            _c(
                              "v-avatar",
                              {
                                attrs: {
                                  color: items.item.foto
                                    ? "#FFF"
                                    : "light-blue darken-4"
                                }
                              },
                              [
                                items.item.foto
                                  ? _c("img", {
                                      staticStyle: {
                                        border: "1px solid #7BAFD4 !important"
                                      },
                                      attrs: {
                                        src: _vm.url_backend + items.item.foto,
                                        alt: items.item.nombres[0]
                                      },
                                      on: {
                                        error: function($event) {
                                          return _vm.handleImageError(
                                            items.item
                                          )
                                        }
                                      }
                                    })
                                  : _c(
                                      "span",
                                      { staticClass: "white--text headline" },
                                      [
                                        _vm._v(
                                          _vm._s(items.item.nombres[0] || "-")
                                        )
                                      ]
                                    )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(items.item.ap_paterno) +
                              " " +
                              _vm._s(items.item.ap_materno) +
                              "\n            " +
                              _vm._s(items.item.nombres) +
                              " " +
                              _vm._s(items.item.ap_casada) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(items.item.tipo_documento) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.nro_doc))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                items.item.correo ? items.item.correo : "-"
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.estado_persona))
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "nowrap text-xs-center" },
                          [
                            items.item.id_estado === 1 &&
                            _vm.es_registro_ad == false
                              ? _c(
                                  "v-tooltip",
                                  { attrs: { bottom: "" } },
                                  [
                                    _vm.es_visualizador_ad == false
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              slot: "activator",
                                              color: "green",
                                              dark: "",
                                              icon: "",
                                              to:
                                                "/personas/ficha-personal/" +
                                                items.item.id
                                            },
                                            slot: "activator"
                                          },
                                          [_c("v-icon", [_vm._v("note")])],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("Ficha personal")])
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _vm.es_registro_ad
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          slot: "activator",
                                          icon: "",
                                          color: "primary"
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.crearActualizarPersona(
                                              items.item
                                            )
                                          }
                                        },
                                        slot: "activator"
                                      },
                                      [_c("v-icon", [_vm._v("edit")])],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [_vm._v("Editar registro")])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _vm.esAdmin &&
                                _vm.es_registro_ad == false &&
                                _vm.es_visualizador_ad == false
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          slot: "activator",
                                          icon: "",
                                          to: "/movilidad/" + items.item.id,
                                          color: "info"
                                        },
                                        slot: "activator"
                                      },
                                      [_c("v-icon", [_vm._v("refresh")])],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [_vm._v("Movilidad")])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49013974", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49013974","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/persona/components/ListadoPersona.vue
// module id = null
// module chunks = 